import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, branch, renderComponent } from 'recompose';
import { Button } from 'react-bootstrap';

import { queryGetAllUserMonthBonusGQL } from '../graphql/allUserMonthBonusApi';
import { queryGetUserMonthBonusMassUpdaterGQL } from '../graphql/getUserMonthBonusMassUpdaterApi';
import SummaryBonusForm from './SummaryBonusForm';
import { FINALIZED } from '../constants';

import { getBonusMonth, getDepartmentId, getDistrictId, getMonthBonusState } from '../selectors';
import { getApiServerUrl } from '../../configuration/selectors';
import linkWithCredentials from '../../../utils/linkWithCredentials';
import { downloadingFileAndUpdatingCredentials } from '../../../utils/downloadUpdatingCredentials';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  allUsersMonthBonuses: PropTypes.array.isRequired,
  districtId: PropTypes.number,
  departmentId: PropTypes.number,
  bonusMonth: PropTypes.string.isRequired,
  monthBonusState: PropTypes.string.isRequired,

  canFinalize: PropTypes.bool,
  apiServerUrl: PropTypes.string.isRequired,
});
/* eslint-enable react/no-unused-prop-types */

const SummaryBonusWrapper = (props) => {
  const {
    allUsersMonthBonuses,
    bonusMonth,
    monthBonusState,
    canFinalize,
  } = props;

  const { apiServerUrl } = props;
  const showButton = (monthBonusState === FINALIZED);

  const openUrl = () => {
    const urlCred = linkWithCredentials(`${apiServerUrl}/month_bonuses`);
    const csvUrl = `${urlCred}&month=${bonusMonth}&with_headings=false`;
    downloadingFileAndUpdatingCredentials(csvUrl);
  };

  return (
    <div>
      {
        showButton
          && (
          <Button
            onClick={openUrl}
            bsStyle="primary"
            className="pull-right"
          >Download Finalized CSV
          </Button>
          )
      }
      <SummaryBonusForm
        canFinalize={canFinalize}
        initialValues={{ members: allUsersMonthBonuses }}
      />
    </div>
  );
};

SummaryBonusWrapper.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    districtId: getDistrictId(state),
    departmentId: getDepartmentId(state),
    bonusMonth: getBonusMonth(state),
    monthBonusState: getMonthBonusState(state),
    apiServerUrl: getApiServerUrl(state),
  };
};
const mapDispatchToProps = {};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withDistrictandDepartment = branch(
  (props) => { return props.districtId && props.departmentId; },
  queryGetUserMonthBonusMassUpdaterGQL,
);

const withNoAllUserMonthBonuses = branch(
  (props) => { return props.allUsersMonthBonuses.length === 0; },
  renderComponent((props) => {
    return (
      <div className="panel-body" style={{ textAlign: 'center' }}>
        <h4>Empty</h4>
        <p className="text-muted">No Employee Bonuses</p>
      </div>
    );
  }),
);

const enhance = compose(
  withRedux,
  queryGetAllUserMonthBonusGQL,
  withNoAllUserMonthBonuses,
  withDistrictandDepartment,
);

export default enhance(SummaryBonusWrapper);
